// extracted by mini-css-extract-plugin
module.exports = {"title":"DomainHappen_title__1aBB0","content":"DomainHappen_content__XP6iC","container":"DomainHappen_container__fyjf8"};